import { Provider } from '@angular/core';
import { ProfileRepository } from './domain/profile.repository';
import { ProfileHttpRepository } from './infrastructure/repository/profile-http.repository';

/**
 * Providers para Profile Repository
 *
 */
export function provideProfileRepository(): Provider[] {
  return [
    {
      provide: ProfileRepository,
      useClass: ProfileHttpRepository,
    },
  ];
}